module.exports = {
  title: '客户开票资料详情',
  route: {
    path: '/finance-manage',
    children: {
      path: 'customer-invoice-data-detail',
    },
  },
};
